export const getCookie = (name: string): string | undefined => {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  if (!match) return undefined;

  return decodeURIComponent(match[1]);
};
